$(document).ready(function(){
    

    $('.owl_fp').owlCarousel({
        loop:true,
        margin:50,
        nav:true,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:2
            },
            1000:{
                items:4
            }
        }
    });


    $('.owl_frag').owlCarousel({
        loop:true,
        margin:36,
        nav:true,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:2
            },
            1000:{
                items:3
            }
        }
    });



    $('header .btn_menu').click(function(){
        if(!$('header').hasClass('active')){
            $('header').addClass('active');
        } else {
            $('header').removeClass('active');
        }
        
    });


    function scrollToAnchor(aid){
        var aTag = $('#' + aid);
        $('html,body').animate({scrollTop: aTag.offset().top},'slow');
    }11
    
    

    $('.ing_ingredient .nv .ct a, .fg_fragrance .nv .ct a, .fg_banner .dv a, .ing_banner a').click(function(){
        var myRel = $(this).attr('rel');
        scrollToAnchor(myRel);
    });

    

    
});